<template>
  <component
    :is="component"
    class="heading"
    :class="[sizeClass, colorClass, fontWeight, fontStyle, alignClass, textTransformClass]">
    <slot/>
  </component>
</template>
<script>
export default {
  name: 'BaseHeading',
  props: {
    size: {
      type: Number,
      default: 4
    },
    color: {
      type: String,
      default: null
    },
    fontWeight: {
      type: String,
      default: null
    },
    fontStyle: {
      type: String,
      default: null
    },
    align: String,
    textTransform: String
  },
  computed: {
    component () {
      return 'h' + this.size
    },
    sizeClass () {
      return 'heading--size-h' + this.size
    },
    colorClass () {
      return this.color ? 'heading--color-' + this.color : ''
    },
    alignClass () {
      return this.align ? 'heading--align-' + this.align : ''
    },
    fontStyleClass () {
      return (this.fontStyle ? `heading--style-${this.fontStyle}` : '')
    },
    textTransformClass () {
      return (this.textTransform ? `heading--text-transform-${this.textTransform}` : '')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './base-heading'
</style>



// WEBPACK FOOTER //
// src/components/BaseHeading/BaseHeading.vue